var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container red-background"},[_c('div',{staticClass:"page-content"},[_c('PurchaseStatusDetails')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }